import React from 'react'
import { Grid, PageSection } from '@superhi/design'
import { InferGetStaticPropsType } from 'next'

import Page from '../../components/Page'
import LibraryPostArticleCard from '../../components/LibraryPostArticleCard'
import LibraryPostVideoCard from '../../components/LibraryPostVideoCard'
import PageHeader from '../../components/PageHeader'
import { PageConfig } from '../../routing/types'
import { API } from '../../api'

import { getStaticProps } from './data'
import { Props } from './data'
import ROUTE from './route'

const VS_1 = { small: 32, medium: 40, large: 56, xlarge: 56 }
const GRID_1_CELL_SPAN_1: React.ComponentProps<typeof Grid.Cell>['span'] = {
  small: 'full',
  medium: 4,
  large: 4,
}

const COLOR: Record<
  API.LibraryGuideColor,
  React.ComponentProps<typeof PageHeader>['backgroundColor']
> = {
  BLUE_01: 'blue',
  GREEN_01: 'green',
  PINK_01: 'pink',
  RED_01: 'red',
  YELLOW_01: 'yellow',
}

const Series: PageConfig<InferGetStaticPropsType<typeof getStaticProps>> = ({
  color,
  title,
  description,
  posts,
  seoDescription,
}) => (
  <Page title={`${title} – Series`} description={seoDescription}>
    <PageHeader
      backgroundColor="pink"
      // backgroundColor={COLOR[color]}
      label="Series"
      title={`${title}`}
      subtitleRichText={description}
    />

    <PageSection>
      <Grid rowGap={VS_1}>
        {posts?.nodes.map((post): React.ReactElement => {
          switch (post.__typename) {
            case 'LibraryPostArticle': {
              return (
                <Grid.Cell key={post.slug} span={GRID_1_CELL_SPAN_1}>
                  <LibraryPostArticleCard {...post} headingLevel="2" noType imageLazy />
                </Grid.Cell>
              )
            }
            case 'LibraryPostVideo': {
              return (
                <Grid.Cell key={post.slug} span={GRID_1_CELL_SPAN_1}>
                  <LibraryPostVideoCard {...post} headingLevel="2" noType imageLazy />
                </Grid.Cell>
              )
            }
          }
        })}
      </Grid>
    </PageSection>
  </Page>
)

Series.route = ROUTE

export { getStaticProps, getStaticPaths } from './data'
export default Series
